import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority"
import { cn } from "src/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium ring-offset-background transition-all duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        /* CTA principal — Teal Yool */
        default:
          "rounded-xl bg-[#007D6E] text-white hover:bg-[#006358] shadow-sm hover:shadow-[0_4px_14px_rgba(0,125,110,0.30)]",
        /* Acción destructiva */
        destructive:
          "rounded-xl bg-destructive text-destructive-foreground hover:bg-destructive/90",
        /* Borde teal */
        outline:
          "rounded-xl border border-[#007D6E] bg-transparent text-[#007D6E] hover:bg-[#007D6E]/5 dark:border-teal-500 dark:text-teal-400",
        /* Navy */
        secondary:
          "rounded-xl bg-[#0E2640] text-white hover:bg-[#0A1B2E] dark:bg-slate-700 dark:hover:bg-slate-600",
        /* Ghost teal */
        ghost:
          "rounded-xl hover:bg-[#007D6E]/8 hover:text-[#007D6E] dark:hover:bg-teal-950",
        /* Link */
        link:
          "text-[#007D6E] underline-offset-4 hover:underline dark:text-teal-400",
      },
      size: {
        default: "h-10 px-4 py-2",
        sm:      "h-9 rounded-lg px-3 text-xs",
        lg:      "h-11 rounded-xl px-8",
        icon:    "h-10 w-10 rounded-xl",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props}
    />
  )
})
Button.displayName = "Button"

export { Button, buttonVariants }
